import { isValidImages, getFrontImage } from '@grandvisionhq/utils';

const getLineItemImageUrl = (variant)=>{
    var ref, ref1;
    const images = isValidImages((ref = variant.media) === null || ref === void 0 ? void 0 : ref.images) ? (ref1 = variant.media) === null || ref1 === void 0 ? void 0 : ref1.images : undefined;
    const imageUrl = getFrontImage(images).url;
    return `${imageUrl}?w=275&fm=jpeg&auto=format`;
};

export { getLineItemImageUrl };
//# sourceMappingURL=get-line-item-image-url.js.map
